import { createRouter, createWebHistory } from 'vue-router';
import store from "../store";

// Auth
import Login from '../views/auth/Login';
import NotFound from '../views/NotFound';

// Dashboard
import Dashboard from '../views/dashboard/Dashboard';
import Home from '../views/dashboard/Home';

// Clients
import ClientsIndex from '../views/dashboard/clients/Index';
import ClientsDetail from '../views/dashboard/clients/Detail';
import ClientsForm from '../views/dashboard/clients/Form';
import AddressForm from '../views/dashboard/clients/AddressForm';

// Pets
import PetsIndex from '../views/dashboard/pets/Index';
import PetsDetail from '../views/dashboard/pets/Detail';
import PetsForm from '../views/dashboard/pets/Form';
import PetCheckupsForm from '../views/dashboard/pets/CheckupForm';

// Quote Requests
import QuoteRequestsIndex from '../views/dashboard/quoteRequests/Index';
import QuoteRequestsDetail from '../views/dashboard/quoteRequests/Detail';

// Appointment Requests
import AppointmentRequestsIndex from '../views/dashboard/appointmentRequests/Index';
import AppointmentRequestsDetail from '../views/dashboard/appointmentRequests/Detail';

// Quotes
import QuotesIndex from '../views/dashboard/quotes/Index';
import QuotesDetail from '../views/dashboard/quotes/Detail';
import QuotesForm from '../views/dashboard/quotes/Form';

// Orders
import OrdersIndex from '../views/dashboard/orders/Index';
import PlansAudit from '../views/dashboard/audit/PlansAudit';

// Frequencies
import FrequenciesIndex from '../views/dashboard/frequencies/Index';
import ReferralSettingsIndex from '../views/dashboard/referralSettings/Index';

// Breeds
import BreedsIndex from '../views/dashboard/breeds/Index';
import BreedsForm from '../views/dashboard/breeds/Form';

// Diet Categories
import DietCategoriesIndex from '../views/dashboard/dietCategories/Index';
import DietCategoriesForm from '../views/dashboard/dietCategories/Form';

// Diet Templates
import DietTemplatesIndex from '../views/dashboard/dietTemplates/Index';
import DietTemplatesDetail from '../views/dashboard/dietTemplates/Detail';
import DietTemplatesForm from '../views/dashboard/dietTemplates/Form';

// Franchises
import FranchisesIndex from '../views/dashboard/franchises/Index';
import FranchisesForm from '../views/dashboard/franchises/Form';
import FranchiseRouter from '../views/dashboard/franchises/FranchiseRouter';
import FranchisesDetail from '../views/dashboard/franchises/Detail';

// Branches
import BranchesDetail from '../views/dashboard/franchises/branches/Detail';
import BranchesForm from '../views/dashboard/franchises/branches/Form';

// Admins
import AdminsIndex from '../views/dashboard/admins/Index';
import AdminsDetail from '../views/dashboard/admins/Detail';
import AdminsForm from '../views/dashboard/admins/Form';

// Roles
import RolesIndex from '../views/dashboard/roles/Index';
import RolesDetail from '../views/dashboard/roles/Detail';
import RolesForm from '../views/dashboard/roles/Form';

// Store
import Store from '../views/dashboard/store/Store';
import ProductsIndex from '../views/dashboard/store/products/Index';
import ProductsDetail from '../views/dashboard/store/products/Detail';
import ProductsForm from '../views/dashboard/store/products/Form';
import ProductCategoriesIndex from '../views/dashboard/store/productCategories/Index';
import ProductCategoriesDetail from '../views/dashboard/store/productCategories/Detail';
import ProductCategoriesForm from '../views/dashboard/store/productCategories/Form';
import CouponsIndex from '../views/dashboard/store/coupons/Index';
import PostsIndex from '../views/dashboard/posts/Index';
import PostsForm from '../views/dashboard/posts/Form';
import CouponsDetail from '../views/dashboard/store/coupons/Detail';
import CouponsForm from '../views/dashboard/store/coupons/Form';
import TagsIndex from '../views/dashboard/store/tags/Index';
import TagsForm from '../views/dashboard/store/tags/Form';
import ShippingTiersIndex from '../views/dashboard/store/shippingTiers/Index';
import ShippingTiersForm from '../views/dashboard/store/shippingTiers/Form';
import ShopOrdersIndex from '../views/dashboard/shop/orders/Index';
import ShopOrdersDetail from '../views/dashboard/shop/orders/Detail';

// Product Orders
import ProductOrdersIndex from '../views/dashboard/productOrders/Index';
import ProductOrdersDetail from '../views/dashboard/productOrders/Detail';

// Reports
import ReportsIndex from '../views/dashboard/reports/Index';
import Monthly from '../views/dashboard/reports/Monthly';
import Biweekly from '../views/dashboard/reports/Biweekly';
import PaymentHealth from '../views/dashboard/reports/PaymentHealth';
import Operational from '../views/dashboard/reports/Operational';
import CustomerHealth from '../views/dashboard/reports/CustomerHealth';
import WalletReport from '../views/dashboard/reports/WalletReport';

// Accounting
import AccountingIndex from '../views/dashboard/accounting/Index';
import IncomesIndex from '../views/dashboard/accounting/incomes/Index';
import IncomesForm from '../views/dashboard/accounting/incomes/Form';
import ExpensesIndex from '../views/dashboard/accounting/expenses/Index';
import ExpensesForm from '../views/dashboard/accounting/expenses/Form';

// Notifications
import NotificationsIndex from '../views/dashboard/notifications/Index';

// barfhero imports
import BarfheroImportIndex from '../views/dashboard/barfheroImport/Index';

// Mass Emails
import MassEmailsIndex from '../views/dashboard/massEmails/Index';
import MassEmailsDetail from '../views/dashboard/massEmails/Detail';
import MassEmailsForm from '../views/dashboard/massEmails/Form';

// Payment Issues
import PaymentIssuesIndex from '../views/dashboard/paymentIssues/Index';

// Production Schedule
import ProductionScheduleIndex from '../views/dashboard/productionSchedule/Index';

// Manual
import ManualIndex from '../views/dashboard/manual/Index';
import ManualGettingStarted from '../views/dashboard/manual/sections/GettingStarted';
import ManualClients from '../views/dashboard/manual/sections/Clients';
import ManualPets from '../views/dashboard/manual/sections/Pets';
import ManualQuoteRequests from '../views/dashboard/manual/sections/QuoteRequests';
import ManualAppointmentRequests from '../views/dashboard/manual/sections/AppointmentRequests';
import ManualPlans from '../views/dashboard/manual/sections/Plans';
import ManualOrders from '../views/dashboard/manual/sections/Orders';
import ManualFranchises from '../views/dashboard/manual/sections/Franchises';
import ManualDietManagement from '../views/dashboard/manual/sections/DietManagement';
import ManualUsers from '../views/dashboard/manual/sections/Users';
import ManualStore from '../views/dashboard/manual/sections/Store';
import ManualAccounting from '../views/dashboard/manual/sections/Accounting';
import ManualReports from '../views/dashboard/manual/sections/Reports';

const routes = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresLogin: true },
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: { breadcrumb: { label: 'Inicio' } },
      },

      {
        path: 'notificaciones',
        name: 'notifications',
        component: NotificationsIndex,
        meta: { breadcrumb: { label: 'Notificaciones' } },
      },

      {
        path: 'clientes',
        name: 'clients',
        redirect: { name: 'clientsIndex' },
        meta: { permission: 'view_clients', breadcrumb: { label: 'Clientes' } },
        children: [
          {
            path: '',
            name: 'clientsIndex',
            component: ClientsIndex,
          },
          {
            path: ':id',
            name: 'clientsDetail',
            component: ClientsDetail,
            meta: { breadcrumb: { label: 'Cliente', dynamic: true } },
          },
          {
            path: ':id/editar',
            name: 'clientsEditForm',
            component: ClientsForm,
            meta: { permission: 'edit_clients', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':clientId/direcciones',
            name: 'addressCreateForm',
            component: AddressForm,
            meta: { permission: 'edit_clients', breadcrumb: { label: 'Nueva Dirección' } },
          },
          {
            path: 'direcciones/:id',
            name: 'addressEditForm',
            component: AddressForm,
            meta: { permission: 'edit_clients', breadcrumb: { label: 'Editar Dirección' } },
          },
        ]
      },

      {
        path: 'mascotas',
        name: 'pets',
        redirect: { name: 'petsIndex' },
        meta: { permission: 'view_pets', breadcrumb: { label: 'Mascotas' } },
        children: [
          {
            path: '',
            name: 'petsIndex',
            component: PetsIndex,
          },
          {
            path: ':id',
            name: 'petsDetail',
            component: PetsDetail,
            meta: { breadcrumb: { label: 'Mascota', dynamic: true } },
          },
          {
            path: ':id/editar',
            name: 'petsEditForm',
            component: PetsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':petId/agregar-evaluacion/:selectedType',
            name: 'petCheckupsCreateForm',
            component: PetCheckupsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Nueva Evaluación' } },
          },
          {
            path: ':id/editar-evaluacion/:selectedType',
            name: 'petCheckupsEditForm',
            component: PetCheckupsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Editar Evaluación' } },
          },
        ]
      },

      {
        path: 'solicitudes',
        name: 'quoteRequests',
        redirect: { name: 'quoteRequestsIndex' },
        meta: { permission: 'view_quote_requests', breadcrumb: { label: 'Solicitudes' } },
        children: [
          {
            path: '',
            name: 'quoteRequestsIndex',
            component: QuoteRequestsIndex
          },
          {
            path: ':id',
            name: 'quoteRequestsDetail',
            component: QuoteRequestsDetail,
            meta: { breadcrumb: { label: 'Solicitud', dynamic: true } },
          },
        ]
      },

      {
        path: 'citas',
        name: 'appointmentRequests',
        redirect: { name: 'appointmentRequestsIndex' },
        meta: { permission: 'view_appointment_requests', breadcrumb: { label: 'Citas' } },
        children: [
          {
            path: '',
            name: 'appointmentRequestsIndex',
            component: AppointmentRequestsIndex
          },
          {
            path: ':id',
            name: 'appointmentRequestsDetail',
            component: AppointmentRequestsDetail,
            meta: { breadcrumb: { label: 'Cita', dynamic: true } },
          },
        ]
      },

      {
        path: 'planes',
        name: 'quotes',
        redirect: { name: 'quotesIndex' },
        meta: { permission: 'view_quotes', breadcrumb: { label: 'Planes' } },
        children: [
          {
            path: '',
            name: 'quotesIndex',
            component: QuotesIndex
          },
          {
            path: 'solicitadas/:id',
            name: 'quoteRequestDetail',
            component: QuotesDetail,
            meta: { breadcrumb: { label: 'Solicitud', dynamic: true } },
          },
          {
            path: 'crear/:id',
            name: 'quotesForm',
            component: QuotesForm,
            meta: { permission: 'edit_quotes', breadcrumb: { label: 'Crear Plan' } },
          },
          {
            path: ':id',
            name: 'quotesDetail',
            component: QuotesDetail,
            meta: { breadcrumb: { label: 'Plan', dynamic: true } },
          }
        ]
      },

      {
        path: 'ordenes',
        name: 'orders',
        redirect: { name: 'ordersIndex' },
        meta: { permission: 'view_orders', breadcrumb: { label: 'Órdenes' } },
        children: [
          {
            path: '',
            name: 'ordersIndex',
            component: OrdersIndex
          },
        ]
      },

      {
        path: 'auditoria-planes',
        name: 'auditPlans',
        component: PlansAudit,
        meta: { permission: 'edit_quotes', breadcrumb: { label: 'Auditoría de Planes' } },
      },

      {
        path: 'programa-produccion',
        name: 'productionSchedule',
        redirect: { name: 'productionScheduleIndex' },
        meta: { permission: 'view_orders', breadcrumb: { label: 'Programa de Producción' } },
        children: [
          {
            path: '',
            name: 'productionScheduleIndex',
            component: ProductionScheduleIndex
          },
        ]
      },

      {
        path: 'frecuencias',
        name: 'frequencies',
        redirect: { name: 'frequenciesIndex' },
        meta: { permission: 'view_frequencies', breadcrumb: { label: 'Frecuencias' } },
        children: [
          {
            path: '',
            name: 'frequenciesIndex',
            component: FrequenciesIndex
          }
        ]
      },

      {
        path: 'novedades',
        name: 'posts',
        redirect: { name: 'postsIndex' },
        meta: { permission: 'view_posts', breadcrumb: { label: 'Novedades' } },
        children: [
          {
            path: '',
            name: 'postsIndex',
            component: PostsIndex,
          },
          {
            path: 'crear',
            name: 'postsCreateForm',
            component: PostsForm,
            meta: { permission: 'edit_posts', breadcrumb: { label: 'Nueva novedad' } },
          },
          {
            path: ':id/editar',
            name: 'postsEditForm',
            component: PostsForm,
            meta: { permission: 'edit_posts', breadcrumb: { label: 'Editar' } },
          },
        ],
      },

      {
        path: 'referidos',
        name: 'referralSettings',
        component: ReferralSettingsIndex,
        meta: { permission: 'view_referral_settings', breadcrumb: { label: 'Programa de Referidos' } },
      },

      {
        path: 'razas',
        name: 'breeds',
        redirect: { name: 'breedsIndex' },
        meta: { permission: 'view_breeds', breadcrumb: { label: 'Razas' } },
        children: [
          {
            path: '',
            name: 'breedsIndex',
            component: BreedsIndex
          },
          {
            path: 'crear',
            name: 'breedsForm',
            component: BreedsForm,
            meta: { breadcrumb: { label: 'Nueva Raza' } },
          }
        ]
      },

      {
        path: 'alimentos',
        name: 'dietCategories',
        redirect: { name: 'dietCategoriesIndex' },
        meta: { permission: 'view_diet_categories', breadcrumb: { label: 'Alimentos' } },
        children: [
          {
            path: '',
            name: 'dietCategoriesIndex',
            component: DietCategoriesIndex
          },
          {
            path: 'crear',
            name: 'dietCategoriesForm',
            component: DietCategoriesForm,
            meta: { breadcrumb: { label: 'Nueva Categoría' } },
          }
        ]
      },

      {
        path: 'plantillas-dietas',
        name: 'dietTemplates',
        redirect: { name: 'dietTemplatesIndex' },
        meta: { permission: 'view_diet_templates', breadcrumb: { label: 'Plantillas de Dieta' } },
        children: [
          {
            path: '',
            name: 'dietTemplatesIndex',
            component: DietTemplatesIndex
          },
          {
            path: 'crear',
            name: 'dietTemplatesForm',
            component: DietTemplatesForm,
            meta: { permission: 'edit_diet_templates', breadcrumb: { label: 'Nueva Plantilla' } },
          },
          {
            path: ':id',
            name: 'dietTemplatesDetail',
            component: DietTemplatesDetail,
            meta: { breadcrumb: { label: 'Plantilla', dynamic: true } },
          },
          {
            path: ':id/editar',
            name: 'dietTemplatesEdit',
            component: DietTemplatesForm,
            meta: { permission: 'edit_diet_templates', breadcrumb: { label: 'Editar' } },
          }
        ]
      },

      {
        path: 'reportes',
        name: 'reports',
        component: ReportsIndex,
        redirect: { name: 'biweekly' },
        meta: { permission: 'view_reports', breadcrumb: { label: 'Reportes' } },
        children: [
          {
            path: 'bisemanal',
            name: 'biweekly',
            component: Biweekly,
            meta: { breadcrumb: { label: 'Bisemanal' } },
          },
          {
            path: 'mensual',
            name: 'monthly',
            component: Monthly,
            meta: { breadcrumb: { label: 'Mensual' } },
          },
          {
            path: 'salud-pagos',
            name: 'paymentHealth',
            component: PaymentHealth,
            meta: { breadcrumb: { label: 'Salud de Pagos' } },
          },
          {
            path: 'operativo',
            name: 'operational',
            component: Operational,
            meta: { breadcrumb: { label: 'Operativo' } },
          },
          {
            path: 'salud-clientes',
            name: 'customerHealth',
            component: CustomerHealth,
            meta: { breadcrumb: { label: 'Salud de Clientes' } },
          },
          {
            path: 'monedero',
            name: 'walletReport',
            component: WalletReport,
            meta: { breadcrumb: { label: 'Monedero' } },
          }
        ]
      },

      {
        path: 'franquicias',
        name: 'franchises',
        redirect: { name: 'franchisesIndex' },
        meta: { permission: 'view_franchises', breadcrumb: { label: 'Franquicias' } },
        children: [
          {
            path: '',
            name: 'franchisesIndex',
            component: FranchisesIndex,
          },
          {
            path: 'crear',
            name: 'franchisesCreateForm',
            component: FranchisesForm,
            meta: { permission: 'edit_franchises', breadcrumb: { label: 'Nueva Franquicia' } },
          },
          {
            path: ':id/editar',
            name: 'franchisesEditForm',
            component: FranchisesForm,
            meta: { permission: 'edit_franchises', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':franchiseId',
            name: 'franchise',
            component: FranchiseRouter,
            meta: { breadcrumb: { label: 'Franquicia', dynamic: true } },
            children: [
              {
                path: '',
                name: 'franchisesDetail',
                component: FranchisesDetail
              },
              {
                path: 'sucursales/crear',
                name: 'branchesCreateForm',
                component: BranchesForm,
                meta: { permission: 'edit_branches', breadcrumb: { label: 'Nueva Sucursal' } },
              },
              {
                path: 'sucursales/:id',
                name: 'branchesDetail',
                component: BranchesDetail,
                meta: { breadcrumb: { label: 'Sucursal', dynamic: true } },
              },
              {
                path: 'sucursales/:id/editar',
                name: 'branchesEditForm',
                component: BranchesForm,
                meta: { permission: 'edit_branches', breadcrumb: { label: 'Editar' } },
              }
            ]
          }
        ]
      },

      {
        path: 'usuarios',
        name: 'admins',
        redirect: { name: 'adminsIndex' },
        meta: { permission: 'view_admins', breadcrumb: { label: 'Usuarios' } },
        children: [
          {
            path: '',
            name: 'adminsIndex',
            component: AdminsIndex
          },
          {
            path: 'crear',
            name: 'adminsCreateForm',
            component: AdminsForm,
            meta: { permission: 'edit_admins', breadcrumb: { label: 'Nuevo Usuario' } },
          },
          {
            path: ':id/editar',
            name: 'adminsEditForm',
            component: AdminsForm,
            meta: { permission: 'edit_admins', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':id',
            name: 'adminsDetail',
            component: AdminsDetail,
            meta: { breadcrumb: { label: 'Usuario', dynamic: true } },
          }
        ]
      },

      {
        path: 'roles',
        name: 'roles',
        redirect: { name: 'rolesIndex' },
        meta: { permission: 'view_roles', breadcrumb: { label: 'Roles' } },
        children: [
          {
            path: '',
            name: 'rolesIndex',
            component: RolesIndex
          },
          {
            path: 'crear',
            name: 'rolesCreateForm',
            component: RolesForm,
            meta: { permission: 'edit_roles', breadcrumb: { label: 'Nuevo Rol' } },
          },
          {
            path: ':id/editar',
            name: 'rolesEditForm',
            component: RolesForm,
            meta: { permission: 'edit_roles', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':id',
            name: 'rolesDetail',
            component: RolesDetail,
            meta: { breadcrumb: { label: 'Rol', dynamic: true } },
          }
        ]
      },

      {
        path: 'contabilidad',
        name: 'accounting',
        component: AccountingIndex,
        redirect: { name: 'incomes' },
        meta: { breadcrumb: { label: 'Contabilidad' } },
        children: [
          {
            path: 'ingresos',
            name: 'incomes',
            redirect: { name: 'incomesIndex' },
            meta: { permission: 'view_incomes', breadcrumb: { label: 'Ingresos' } },
            children: [
              {
                path: '',
                name: 'incomesIndex',
                component: IncomesIndex,
                meta: { permission: 'edit_incomes' },
              },
              {
                path: 'crear',
                name: 'incomesCreateForm',
                component: IncomesForm,
                meta: { permission: 'edit_incomes', breadcrumb: { label: 'Nuevo Ingreso' } },
              },
              {
                path: ':id/editar',
                name: 'incomesEditForm',
                component: IncomesForm,
                meta: { permission: 'edit_incomes', breadcrumb: { label: 'Editar' } },
              },
            ]
          },
          {
            path: 'egresos',
            name: 'expenses',
            redirect: { name: 'expensesIndex' },
            meta: { permission: 'view_expenses', breadcrumb: { label: 'Egresos' } },
            children: [
              {
                path: '',
                name: 'expensesIndex',
                component: ExpensesIndex,
                meta: { permission: 'edit_expenses' },
              },
              {
                path: 'crear',
                name: 'expensesCreateForm',
                component: ExpensesForm,
                meta: { permission: 'edit_expenses', breadcrumb: { label: 'Nuevo Egreso' } },
              },
              {
                path: ':id/editar',
                name: 'expensesEditForm',
                component: ExpensesForm,
                meta: { permission: 'edit_expenses', breadcrumb: { label: 'Editar' } },
              },
            ]
          },
        ]
      },

      {
        path: 'tienda',
        name: 'store',
        component: Store,
        redirect: { name: 'productsIndex' },
        meta: { permission: 'view_shop', breadcrumb: { label: 'Tienda' } },
        children: [
          {
            path: 'productos',
            name: 'products',
            redirect: { name: 'productsIndex' },
            meta: { permission: 'view_products', breadcrumb: { label: 'Productos' } },
            children: [
              {
                path: '',
                name: 'productsIndex',
                component: ProductsIndex
              },
              {
                path: 'crear',
                name: 'productsCreateForm',
                component: ProductsForm,
                meta: { permission: 'edit_products', breadcrumb: { label: 'Nuevo Producto' } },
              },
              {
                path: ':id/editar',
                name: 'productsEditForm',
                component: ProductsForm,
                meta: { permission: 'edit_products', breadcrumb: { label: 'Editar' } },
              },
              {
                path: ':id',
                name: 'productsDetail',
                component: ProductsDetail,
                meta: { breadcrumb: { label: 'Producto', dynamic: true } },
              }
            ]
          },

          {
            path: 'categorias',
            name: 'productCategories',
            redirect: { name: 'productCategoriesIndex' },
            meta: { permission: 'view_product_categories', breadcrumb: { label: 'Categorías' } },
            children: [
              {
                path: '',
                name: 'productCategoriesIndex',
                component: ProductCategoriesIndex
              },
              {
                path: 'crear',
                name: 'productsCategoriesCreateForm',
                component: ProductCategoriesForm,
                meta: { permission: 'edit_product_categories', breadcrumb: { label: 'Nueva Categoría' } },
              },
              {
                path: ':id/editar',
                name: 'productCategoriesEditForm',
                component: ProductCategoriesForm,
                meta: { permission: 'edit_product_categories', breadcrumb: { label: 'Editar' } },
              },
              {
                path: ':id',
                name: 'productCategoriesDetail',
                component: ProductCategoriesDetail,
                meta: { breadcrumb: { label: 'Categoría', dynamic: true } },
              }
            ]
          },

          {
            path: 'cupones',
            name: 'coupons',
            redirect: { name: 'couponsIndex' },
            meta: { permission: 'view_coupons', breadcrumb: { label: 'Cupones' } },
            children: [
              {
                path: '',
                name: 'couponsIndex',
                component: CouponsIndex,
              },
              {
                path: 'crear',
                name: 'couponsCreateForm',
                component: CouponsForm,
                meta: { permission: 'edit_coupons', breadcrumb: { label: 'Nuevo Cupón' } },
              },
              {
                path: ':id/editar',
                name: 'couponsEditForm',
                component: CouponsForm,
                meta: { permission: 'edit_coupons', breadcrumb: { label: 'Editar' } },
              },
              {
                path: ':id',
                name: 'couponsDetail',
                component: CouponsDetail,
                meta: { breadcrumb: { label: 'Cupón', dynamic: true } },
              },
            ],
          },

          {
            path: 'orders',
            name: 'shopOrders',
            redirect: { name: 'shopOrdersIndex' },
            meta: { permission: 'view_shop_orders', breadcrumb: { label: 'Pedidos en línea' } },
            children: [
              {
                path: '',
                name: 'shopOrdersIndex',
                component: ShopOrdersIndex,
              },
              {
                path: ':id',
                name: 'shopOrdersDetail',
                component: ShopOrdersDetail,
                meta: { breadcrumb: { label: 'Pedido', dynamic: true } },
              },
            ],
          },

          {
            path: 'etiquetas',
            name: 'tags',
            redirect: { name: 'tagsIndex' },
            meta: { permission: 'view_tags', breadcrumb: { label: 'Etiquetas' } },
            children: [
              {
                path: '',
                name: 'tagsIndex',
                component: TagsIndex,
              },
              {
                path: 'crear',
                name: 'tagsCreateForm',
                component: TagsForm,
                meta: { permission: 'edit_tags', breadcrumb: { label: 'Nueva Etiqueta' } },
              },
              {
                path: ':id/editar',
                name: 'tagsEditForm',
                component: TagsForm,
                meta: { permission: 'edit_tags', breadcrumb: { label: 'Editar' } },
              },
            ],
          },

          {
            path: 'envios',
            name: 'shippingTiers',
            redirect: { name: 'shippingTiersIndex' },
            meta: { permission: 'view_shipping_tiers', breadcrumb: { label: 'Envíos' } },
            children: [
              { path: '', name: 'shippingTiersIndex', component: ShippingTiersIndex },
              { path: 'crear', name: 'shippingTiersCreateForm', component: ShippingTiersForm, meta: { permission: 'edit_shipping_tiers', breadcrumb: { label: 'Nuevo rango' } } },
              { path: ':id/editar', name: 'shippingTiersEditForm', component: ShippingTiersForm, meta: { permission: 'edit_shipping_tiers', breadcrumb: { label: 'Editar' } } },
            ],
          },
        ]
      },

      {
        path: 'ordenes-compra',
        name: 'productOrders',
        redirect: { name: 'productOrdersIndex' },
        meta: { permission: 'view_product_orders', breadcrumb: { label: 'Órdenes de Compra' } },
        children: [
          {
            path: '',
            name: 'productOrdersIndex',
            component: ProductOrdersIndex
          },
          {
            path: ':id',
            name: 'productOrdersDetail',
            component: ProductOrdersDetail,
            meta: { breadcrumb: { label: 'Orden de Compra', dynamic: true } },
          },
        ]
      },

      {
        path: 'barfhero-imports',
        name: 'barfheroImport',
        redirect: { name: 'barfheroImportIndex' },
        meta: { permission: 'view_admins', breadcrumb: { label: 'Importación Barfhero' } },
        children: [
          {
            path: '',
            name: 'barfheroImportIndex',
            component: BarfheroImportIndex
          },
        ]
      },

      {
        path: 'emails',
        name: 'massEmails',
        redirect: { name: 'massEmailsIndex' },
        meta: { permission: 'manage_emails', breadcrumb: { label: 'Emails Masivos' } },
        children: [
          {
            path: '',
            name: 'massEmailsIndex',
            component: MassEmailsIndex,
          },
          {
            path: 'crear',
            name: 'massEmailsForm',
            component: MassEmailsForm,
            meta: { breadcrumb: { label: 'Nuevo Email' } },
          },
          {
            path: ':id',
            name: 'massEmailsDetail',
            component: MassEmailsDetail,
            meta: { breadcrumb: { label: 'Email', dynamic: true } },
          },
          {
            path: ':id/editar',
            name: 'massEmailsEdit',
            component: MassEmailsForm,
            meta: { breadcrumb: { label: 'Editar' } },
          },
        ]
      },

      {
        path: 'problemas-pago',
        name: 'paymentIssues',
        redirect: { name: 'paymentIssuesIndex' },
        meta: { permission: 'view_quotes', breadcrumb: { label: 'Problemas de Pago' } },
        children: [
          {
            path: '',
            name: 'paymentIssuesIndex',
            component: PaymentIssuesIndex,
          },
        ]
      },

      {
        path: 'manual',
        name: 'manual',
        component: ManualIndex,
        redirect: { name: 'manualGettingStarted' },
        meta: { breadcrumb: { label: 'Manual' } },
        children: [
          {
            path: 'primeros-pasos',
            name: 'manualGettingStarted',
            component: ManualGettingStarted,
            meta: { breadcrumb: { label: 'Primeros Pasos' } },
          },
          {
            path: 'clientes',
            name: 'manualClients',
            component: ManualClients,
            meta: { breadcrumb: { label: 'Clientes' } },
          },
          {
            path: 'mascotas',
            name: 'manualPets',
            component: ManualPets,
            meta: { breadcrumb: { label: 'Mascotas' } },
          },
          {
            path: 'solicitudes',
            name: 'manualQuoteRequests',
            component: ManualQuoteRequests,
            meta: { breadcrumb: { label: 'Solicitudes' } },
          },
          {
            path: 'citas',
            name: 'manualAppointmentRequests',
            component: ManualAppointmentRequests,
            meta: { breadcrumb: { label: 'Citas con Especialista' } },
          },
          {
            path: 'planes',
            name: 'manualPlans',
            component: ManualPlans,
            meta: { breadcrumb: { label: 'Planes' } },
          },
          {
            path: 'ordenes',
            name: 'manualOrders',
            component: ManualOrders,
            meta: { breadcrumb: { label: 'Órdenes' } },
          },
          {
            path: 'franquicias',
            name: 'manualFranchises',
            component: ManualFranchises,
            meta: { breadcrumb: { label: 'Franquicias' } },
          },
          {
            path: 'alimentos',
            name: 'manualDietManagement',
            component: ManualDietManagement,
            meta: { breadcrumb: { label: 'Alimentos' } },
          },
          {
            path: 'usuarios',
            name: 'manualUsers',
            component: ManualUsers,
            meta: { breadcrumb: { label: 'Usuarios' } },
          },
          {
            path: 'tienda',
            name: 'manualStore',
            component: ManualStore,
            meta: { breadcrumb: { label: 'Tienda' } },
          },
          {
            path: 'contabilidad',
            name: 'manualAccounting',
            component: ManualAccounting,
            meta: { breadcrumb: { label: 'Contabilidad' } },
          },
          {
            path: 'reportes-manual',
            name: 'manualReports',
            component: ManualReports,
            meta: { breadcrumb: { label: 'Reportes' } },
          }
        ]
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    component: NotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Clear dynamic breadcrumb labels when navigating to a different route
  // so stale entity names don't bleed into the new route's breadcrumb trail.
  if (to.name !== from.name) {
    store.commit('clearBreadcrumbLabels');
  }

  if (to.matched.some(record => record.meta.requiresLogin) && !store.state.user) {
    next({ name: 'login' });
    return;
  }

  if (to.matched.some(record => record.meta.permission)) {
    if (store.state.user.admin.is_super) {
      next();
      return;
    }

    const requiredPermission = to.meta.permission;

    const hasPermission = store.state.user.role.permissions.some(permission => permission.slug === requiredPermission);

    if (!hasPermission) {
      next({ name: 'home' });
      return;
    }
  }

  next();
});

export default router
